import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { routes } from '../../../redux/api/routes';

import _ from 'lodash';

/* Actions */
import {
	createPriceTags
} from '../../../redux/actions';

let { productGEUrl, s3StaticDataURL } = routes;

class CreatePriceTags extends Component {

    constructor(props) {
        super(props);
        this.state = {
			selectedItems: null,
			createPriceTag: {
				param: {
					format: 'P',
		            size: '8511',
					items: []
				},
				error: {}
			},
			errorMessage: '',
			samplePDFUrls: [
				{
					size: '8511',
					format: {
						L: '/public/PriceTag/Example0.pdf',
						P: '/public/PriceTag/Example1.pdf'
					}
				}, {
					size: '5585',
					format: {
						L: '/public/PriceTag/Example4.pdf',
						P: '/public/PriceTag/Example5.pdf'
					}
				}, {
					size: '5070',
					format: {
						L: '/public/PriceTag/Example3.pdf',
						P: '/public/PriceTag/Example2.pdf'
					}
				}
			]
        }
    }

	componentDidMount() {
		if(this.props.state.priceTags.selectedItems && this.props.state.priceTags.selectedItems.length > 0) {
			const items = this.props.state.priceTags.selectedItems.map((item, index) => {
				return {
					sku: item.item,
					headerText: "",
					regularPriceDescription: "",
					regularPrice: "",
					salePriceDescription: "",
					salePrice: "",
					rebatePriceDescription: "",
					rebatePrice: "",
					finalPriceDescription: "",
					finalPrice: "",
					serviceContractPriceDescription: "",
					serviceContract: "",
					imagePath: item.imagePath
				}
			})
			this.setState({
				selectedItems: this.props.state.priceTags.selectedItems,
				createPriceTag: {
					...this.state.createPriceTag,
					param: {
						...this.state.createPriceTag.param,
						items: items
					}
				}
			})
		} else {
			browserHistory.push('/list');
		}
	}

	updateParams(formName, event) {
		//Reseting Errors on change
		var error = this.state[formName].error;
		for (var key in error) {
			if (error.hasOwnProperty(key)) {
				error[key] = '';
			}
		}
		this.setState({
			[formName]: {
				...this.state[formName],
				param: {
					...this.state[formName].param,
					[event.target.name]: event.target.value
				},
				error: error
			},
			errorMessage: ''
		});
	}

	updateParamsItems(formName, arrayName, fieldName, index, event) {
		let items = this.state[formName].param[arrayName];
		items[index] = {
			...items[index],
			[fieldName]: event.target.value
		}
		this.setState({
			[formName]: {
				...this.state[formName],
				param :{
					...this.state[formName].param,
					[arrayName]: items
				}
			}
		})
	}

    handleSample(event){
        event.preventDefault();
		let pdfUrl = _.find(this.state.samplePDFUrls, ['size', this.state.createPriceTag.param.size]);
		if(pdfUrl) {
			pdfUrl = pdfUrl.format[this.state.createPriceTag.param.format];
		}
		window.open(s3StaticDataURL + pdfUrl);
    }

	onKeyValidateNumeric(e) {
		if((e.charCode === 46 && !(e.target.value !== '' && e.target.value.indexOf(".") === -1)) || (e.charCode !== 46 && !(e.charCode > 47 && e.charCode < 58)) || (e.target.value.indexOf(".") !== -1 && e.target.value.substring(e.target.value.indexOf(".")).length - 1 === 2))  {
            e.preventDefault();
        }
    }

	handleCreatePriceTags(event) {
		event.preventDefault();
		this.props.createPriceTags(this.state.createPriceTag.param, (response) => {
			if(response.status)
            	window.open(response.responseObject, '_blank');
			else {
				self.setState({
					errorMessage: 'Unable to create price tags.'
				})
			}
		});
	}

    render() {
        return (
			<div>
		        <div className="push">
					<h1 className="pageTitle">Create Price Tags</h1>
		        </div>
		        <form className="createPriceTagsForm" name="createPriceTagsForm" id="createPriceTagsForm" action="">
		          	<div className="push">
		            	<h2>Select Price Tag Layout</h2>
		            	<div className="indented">
			              	<div className="columns createPriceTagColumns">
				                <div className="column column1">
									<table className="formTableTypeA relaxed">
										<tbody>
											<tr>
												<td>Size</td>
												<td>
													<label><input type="radio" name="size" defaultValue="8511" onClick={this.updateParams.bind(this, 'createPriceTag')} defaultChecked="checked" /> 8.5 × 11</label>
													&nbsp;
													<label><input type="radio" name="size" defaultValue="5585" onClick={this.updateParams.bind(this, 'createPriceTag')} /> 5.5 × 8.5</label>
													&nbsp;
													<label><input type="radio" name="size" defaultValue="5070" onClick={this.updateParams.bind(this, 'createPriceTag')} /> 5 × 7 <i>(no photo included)</i></label>
												</td>
											</tr>
											<tr>
												<td>Format</td>
												<td>
													<label>
														<input type="radio" name="format" defaultValue="P" id="layoutPortrait" onClick={this.updateParams.bind(this, 'createPriceTag')} defaultChecked="checked" />
														<img className="icon" src="../images/icon-layout-portrait.png" width={24} height={29} alt="Layout Portrait" title="Layout Portrait" />
														Portrait
													</label>
													&nbsp;
													<label>
														<input type="radio" name="format" defaultValue="L" onClick={this.updateParams.bind(this, 'createPriceTag')} id="layoutLandscape" />
														<img className="icon" src="../images/icon-layout-landscape.png" width={29} height={24} alt="Layout Landscape" title="Layout Landscape" />
														Landscape
													</label>
												</td>
											</tr>
										</tbody>
									</table>
				                </div>
								<div className="column column2">
									<div className="viewPriceTagShadedBox">
										<a href="" onClick={this.handleSample.bind(this)}>View example price tag</a><br />
										based on your layout selections.
									</div>
								</div>
			              	</div>
		            	</div>
		          	</div>
		          	<div className="push">
		            	<h2>Input Descriptions &amp; Prices</h2>
						<div className="indented">
							{this.state.selectedItems && this.state.selectedItems.map((item, index) => {
								return <div key={index} className="inputModelDescriptionPrice">
									<div className="topPortionColumns">
										<div className="column1">
										<p><img className="thumb" src={item.imagePath} width={96} height={100} alt="Product" title="Product" /></p>
										</div>
										<div className="column2">
											<p><b>{item.item}</b><br />{item.itemDescription}</p>
											<p><label><b>Price Tag Header</b><br /><input maxLength={25} onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'headerText', index)} className="fullWidth" type="text" name="headerText" placeholder="e.g., Special" /></label></p>
										</div>
									</div>
									<table className="descriptionPriceTable">
										<thead>
											<tr>
												<th>Description</th>
												<th>Price ($0.00)</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td><input className="fullWidth" type="text" onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'regularPriceDescription', index)} name="regularPriceDescription" placeholder="e.g., Regular Price" /></td>
												<td><input className="fullWidth" type="text" onDrop={this.props.doNothing} onPaste={this.props.doNothing} onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'regularPrice', index)} onKeyPress={this.onKeyValidateNumeric} name="regularPrice" placeholder="e.g., 0.00" /></td>
											</tr>
											<tr>
												<td><input className="fullWidth" type="text" onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'salePriceDescription', index)} name="salePriceDescription" placeholder="e.g., Sale Price" /></td>
												<td><input className="fullWidth" type="text" onDrop={this.props.doNothing} onPaste={this.props.doNothing} onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'salePrice', index)} onKeyPress={this.onKeyValidateNumeric} name="salePrice" placeholder="e.g., 0.00" /></td>
											</tr>
											<tr>
												<td><input className="fullWidth" type="text" onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'rebatePriceDescription', index)} name="rebatePriceDescription" placeholder="e.g., Rebate" /></td>
												<td><input className="fullWidth" type="text" onDrop={this.props.doNothing} onPaste={this.props.doNothing} onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'rebatePrice', index)} onKeyPress={this.onKeyValidateNumeric} name="rebatePrice" placeholder="e.g., 0.00" /></td>
											</tr>
											<tr>
												<td><input className="fullWidth" type="text" onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'finalPriceDescription', index)} name="finalPriceDescription" placeholder="e.g., Your Price" /></td>
												<td><input className="fullWidth" type="text" onDrop={this.props.doNothing} onPaste={this.props.doNothing} onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'finalPrice', index)} onKeyPress={this.onKeyValidateNumeric} name="finalPrice" placeholder="e.g., 0.00" /></td>
											</tr>
										</tbody>
									</table>
									<table className="descriptionPriceTable">
										<thead>
											<tr>
												<th>Description</th>
												<th>Service Contract Price ($0.00)</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td><input className="fullWidth" type="text" onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'serviceContractPriceDescription', index)} name="serviceContractPriceDescription" placeholder="e.g., Service Plan" /></td>
												<td><input className="fullWidth" type="text" onDrop={this.props.doNothing} onPaste={this.props.doNothing} onChange={this.updateParamsItems.bind(this, 'createPriceTag', 'items', 'serviceContract', index)} onKeyPress={this.onKeyValidateNumeric} name="serviceContract" placeholder="e.g., 0.00" /></td>
											</tr>
										</tbody>
									</table>
								</div>
							})}
						</div>
		          	</div> {/* / .push */}
					<p className="textRight">
						<input type="submit" onClick={this.handleCreatePriceTags.bind(this)} value="Create Price Tags" />
					</p>
		        </form>	{/* / .createPriceTagsForm#createPriceTagsForm */}
	      	</div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	createPriceTags: (payload, callback) => dispatch(createPriceTags(payload, callback))
});

CreatePriceTags = connect(mapStateToProps, mapDispatchToProps)(CreatePriceTags);
export default CreatePriceTags;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/CreatePriceTags/index.js